import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import candidateCountImg from '../../../static/illustrations/candidate-count.svg';
import { SimpleJob } from '../../../types/job';
import { TextButton } from '../../global/components/Button/Button';
import RichText from '../../global/components/RichText';
import ColumnCard from '../../global/layouts/ColumnCard/ColumnCard';
import { FormSection, NextSteps, StyledButton } from '../Profile/styles';

import content from './content';

import type { Control, FieldValues } from 'react-hook-form';

const formSchema = yup
    .object()
    .shape({
        description: yup.string().required(),
        shortDescription: yup
            .string()
            .required()
            .max(
                300,
                'Share a shorter description of the job to attract candidates.'
            )
    })
    .required();

export default function DescriptionSlide(props: {
    job: SimpleJob;
    setJob: (job: SimpleJob) => void;
    candidateCount: number;
    prevURL: string;
    onClose: () => Promise<void>;
    isEdit: boolean;
}) {
    const {
        handleSubmit,
        formState: { errors },
        control
    } = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            description: props.job.description,
            shortDescription: props.job.shortDescription
        }
    });

    const onSubmit = (data: {
        description: string;
        shortDescription: string;
    }) => {
        props.setJob({
            ...props.job,
            description: data.description,
            shortDescription: data.shortDescription
        });
    };

    return (
        <ColumnCard
            closeScreen
            step={2}
            screenType={'job'}
            image={{
                src: candidateCountImg,
                alt: 'total candidates'
            }}
            onClose={props.onClose}
            wide
        >
            <FormSection onSubmit={handleSubmit(onSubmit)}>
                <Typography
                    variant='h2'
                    component='h1'
                    fontWeight='400'
                    sx={{ mb: 1 }}
                >
                    {'Create Job Posting'}
                </Typography>
                <div style={{ marginBottom: '8px' }}>
                    <Typography>
                        <p>{`Job Description: ${content.description.body}`}</p>
                    </Typography>
                    <RichText
                        id={'description'}
                        control={control as unknown as Control<FieldValues>}
                    />
                </div>
                <div style={{ marginBottom: '8px' }}>
                    <Typography>
                        <p>{`Short Description: ${content.shortDescription.body}.`}</p>
                    </Typography>
                    <RichText
                        id={'shortDescription'}
                        control={control as unknown as Control<FieldValues>}
                        simple
                        error={errors.shortDescription?.message}
                    />
                </div>
                <NextSteps>
                    {!props.isEdit && (
                        <TextButton to={props.prevURL}>
                            {content.common.back}
                        </TextButton>
                    )}
                    <StyledButton variant='outlined' sx={{ m: 2 }} submit>
                        {props.isEdit ? 'Save' : content.common.submit}
                    </StyledButton>
                </NextSteps>
            </FormSection>
        </ColumnCard>
    );
}
